import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Seo from '@/components/feature/Seo';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import TimelineSection from './components/TimelineSection';
import Testimonials from './components/Testimonials';
import HomeFaq from './components/HomeFaq';
import CtaSection from './components/CtaSection';
import { FAQS } from '@/mocks/faqs';
import { SITE } from '@/mocks/site';

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE.name,
        alternateName: SITE.englishName,
        description: SITE.intro,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: '/archive?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: SITE.name,
        description: `${SITE.positioning}${SITE.intro}`,
        foundingDate: SITE.founded,
        email: SITE.email,
        knowsAbout: ['网络文化考古', '早期论坛', '被删内容存档', '小众亚文化'],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQS.slice(0, 5).map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
    [],
  );

  return (
    <>
      <Seo
        title="黑料百科 | 冷门小众内容考古挖掘 · 被删尘封记忆档案馆"
        description="黑料百科专注冷门、小众、早期、被删与尘封的网络内容考古挖掘，整理论坛往事、消失网站与亚文化记忆，满足你对隐秘角落的猎奇心。"
        keywords="黑料百科,冷门,小众,早期,被删,考古,尘封,网络考古,早期论坛"
        path="/"
        jsonLd={jsonLd}
      />
      <ScrollToTop />
      <Navbar />
      <main className="w-full">
        <Hero />
        <StatsBar />
        <CategoryGrid />
        <FeaturedArticles />
        <TimelineSection />
        <Testimonials />
        <HomeFaq />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}